import React, { useRef, useEffect } from "react";
import "./amenitiesList.css";

const AmenitiesList = ({ propertyData, onClose }) => {
  const overlayRef = useRef(null);

  const handleClickOutside = (e) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const sections = [
    {
      label: "Furnished Amenities",
      key: "furnished_amenities",
      data: propertyData?.furnished_amenities,
    },
    {
      label: "Semi-Furnished Amenities",
      key: "semifurnished_amenities",
      data: propertyData?.semifurnished_amenities,
    },
    {
      label: "Un-Furnished Amenities",
      key: "unfurnished_amenities",
      data: propertyData?.unfurnished_amenities,
    },
  ];

  const visibleSections = sections.filter(
    ({ data }) => Array.isArray(data) && data.length > 0
  );

  return (
    <div
      className="amenities-overlay"
      ref={overlayRef}
      onClick={handleClickOutside}
    >
      <div className="amenities-modal">

        {/* Sticky Header */}
        <div className="amenities-modal__header">
          <p className="amenities-modal__title">Property Amenities</p>
          <button className="amenities-modal__close-btn" onClick={onClose}>
            <p>✕</p>
          </button>
        </div>

        {/* Body */}
        <div className="amenities-modal__body">
          {visibleSections.length === 0 ? (
            <p className="amenities-modal__empty">No Amenities Available</p>
          ) : (
            visibleSections.map(({ label, data }) => (
              <div className="amenities-section" key={label}>
                <h1 className="amenities-section__heading">
                  {label}
                  <span className="amenities-section__count">({data.length})</span>
                </h1>
                {data.map((amenity, idx) => (
                  <div className="amenities-section__row" key={idx}>
                    <img
                      className="amenities-section__icon"
                      src={amenity.image}
                      alt={amenity.name}
                    />
                    <h4 className="amenities-section__name">{amenity.name}</h4>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
};

export default AmenitiesList;